'use strict';
var __assign =
	(this && this.__assign) ||
	function () {
		__assign =
			Object.assign ||
			function (t) {
				for (var s, i = 1, n = arguments.length; i < n; i++) {
					s = arguments[i];
					for (var p in s)
						if (Object.prototype.hasOwnProperty.call(s, p))
							t[p] = s[p];
				}
				return t;
			};
		return __assign.apply(this, arguments);
	};
var __rest =
	(this && this.__rest) ||
	function (s, e) {
		var t = {};
		for (var p in s)
			if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
				t[p] = s[p];
		if (s != null && typeof Object.getOwnPropertySymbols === 'function')
			for (
				var i = 0, p = Object.getOwnPropertySymbols(s);
				i < p.length;
				i++
			)
				if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
		return t;
	};
Object.defineProperty(exports, '__esModule', { value: true });
var classNames = require('classnames');
var React = require('react');
var trackMetric_1 = require('../../metrics/trackMetric');
var icon_types_1 = require('../../types/icon.types');
var Badge_1 = require('../Badge');
var FontAwesome_1 = require('../FontAwesome');
var SafeAnchor_1 = require('../SafeAnchor');
var CLASS_NAME = 'i-btn';
var ButtonMode;
(function (ButtonMode) {
	ButtonMode['Link'] = 'link';
	ButtonMode['Primary'] = 'primary';
	ButtonMode['Secondary'] = 'outline-secondary';
	ButtonMode['Tertiary'] = 'secondary';
})((ButtonMode = exports.ButtonMode || (exports.ButtonMode = {})));
var ButtonType;
(function (ButtonType) {
	ButtonType['Button'] = 'button';
	ButtonType['Reset'] = 'reset';
	ButtonType['Submit'] = 'submit';
})((ButtonType = exports.ButtonType || (exports.ButtonType = {})));
var buttonContent = function (props) {
	var icon = props.showLoading ? icon_types_1.Icon.Loading : props.iconName;
	return React.createElement(
		React.Fragment,
		null,
		icon &&
			React.createElement(FontAwesome_1.FontAwesome, {
				name: icon,
				pulse: props.showLoading,
			}),
		!props.labelHidden && React.createElement('span', null, props.label),
		props.children,
		props.badge &&
			React.createElement(Badge_1.Badge, __assign({}, props.badge))
	);
};
var Button = function (_a) {
	var buttonRef = _a.buttonRef,
		children = _a.children,
		label = _a.label,
		mode = _a.mode,
		iconName = _a.iconName,
		badge = _a.badge,
		href = _a.href,
		target = _a.target,
		className = _a.className,
		onClick = _a.onClick,
		showLoading = _a.showLoading,
		labelHidden = _a.labelHidden,
		metricOptions = _a.metricOptions,
		type = _a.type,
		restProps = __rest(_a, [
			'buttonRef',
			'children',
			'label',
			'mode',
			'iconName',
			'badge',
			'href',
			'target',
			'className',
			'onClick',
			'showLoading',
			'labelHidden',
			'metricOptions',
			'type',
		]);
	var _b;
	var classes = classNames(
		className,
		CLASS_NAME,
		'btn',
		'btn-' + mode,
		((_b = {
			'btn-raised': mode === ButtonMode.Primary,
		}),
		(_b[CLASS_NAME + '--loading'] = showLoading),
		_b)
	);
	return href
		? React.createElement(
				SafeAnchor_1.SafeAnchor,
				__assign(
					{
						'aria-label': labelHidden ? label : null,
						className: classes,
						role: SafeAnchor_1.SafeAnchor.Role.Button,
						href: href,
						target: target,
						onClick: trackMetric_1.trackMetric(
							metricOptions,
							onClick
						),
						anchorRef: buttonRef,
					},
					restProps
				),
				buttonContent({
					badge: badge,
					children: children,
					iconName: iconName,
					label: label,
					labelHidden: labelHidden,
					showLoading: showLoading,
				})
		  )
		: React.createElement(
				'button',
				__assign(
					{
						'aria-label': labelHidden ? label : null,
						className: classes,
						onClick: trackMetric_1.trackMetric(
							metricOptions,
							onClick
						),
						ref: buttonRef,
						type: type,
					},
					restProps
				),
				buttonContent({
					badge: badge,
					children: children,
					iconName: iconName,
					label: label,
					labelHidden: labelHidden,
					showLoading: showLoading,
				})
		  );
};
exports.Button = Button;
Button.Mode = ButtonMode;
Button.Type = ButtonType;
Button.Target = SafeAnchor_1.SafeAnchor.Target;
Button.defaultProps = {
	mode: Button.Mode.Secondary,
	type: Button.Type.Button,
};
//# sourceMappingURL=Button.js.map
